import localConfig from './local.config'
import hlgConfig from './hlg.config'
import devConfig from './dev.config'
import prdConfig from './prd.config'
import drpConfig from './drp.config'

module.exports = function Config({ constants }) {
  const { APP: { environment } } = constants

  if (environment === 'production') {
    return { ...prdConfig }
  }

  if (environment === 'homologation') {
    return hlgConfig
  }

  if (environment === 'development') {
    return devConfig
  }

  if (environment === 'drp') {
    return drpConfig
  }

  return localConfig
}
